// IncidenciasEmpleado.jsx
import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";

export default function IncidenciasEmpleado() {
  const { token, loading, user } = useContext(AuthContext);
  const [incidencias, setIncidencias] = useState([]);
  const [generalError, setGeneralError] = useState("");
  const [notification, setNotification] = useState("");
  const [filterEstado, setFilterEstado] = useState(""); // por defecto mostrar todas

  const loadIncidencias = async () => {
    if (!token) return;
    try {
      const res = await api.get("/incidencias/mias", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setIncidencias(res.data);
    } catch (err) {
      setGeneralError("Error al cargar las incidencias.");
    }
  };

  useEffect(() => {
    loadIncidencias();
  }, [token]);

  if (loading) return <p className="text-center mt-5">Cargando...</p>;

  // Filtrar por estado si el usuario selecciona uno
  const incidenciasFiltradas = filterEstado
    ? incidencias.filter((i) => i.estado === filterEstado)
    : incidencias;

  const getHoraCorrecta = (comentario) => {
    const match = comentario.match(/\(Hora correcta:\s*([0-9]{2}:[0-9]{2})\)/);
    return match ? match[1] : null;
  };

  return (
    <div className="container my-4">
      <h1 className="fs-3 fw-bold">Mis incidencias</h1>

      {notification && <div className="alert alert-success">{notification}</div>}
      {generalError && <div className="alert alert-danger">{generalError}</div>}

      {/* Filtro por estado */}
      <div className="mb-3 d-flex gap-2 align-items-center">
        <label className="fw-bold">Filtrar por estado:</label>
        <select
          className="form-select w-auto"
          value={filterEstado}
          onChange={(e) => setFilterEstado(e.target.value)}
        >
          <option value="">Todos</option>
          <option value="pendiente">Pendiente</option>
          <option value="resuelta">Resuelta</option>
          <option value="rechazada">Rechazada</option>
        </select>
      </div>

      {/* Lista de incidencias */}
      {incidenciasFiltradas.length > 0 ? (
        <div className="row g-3">
          {incidenciasFiltradas.map((i) => {
            const horaCorrecta = getHoraCorrecta(i.comentario);
            return (
              <div key={i.id} className="col-12 col-md-6 col-lg-4">
                <div className="card shadow-sm p-3 rounded-4 h-100">
                  <div className="d-flex justify-content-between mb-2">
                    <strong>{i.tipo.toUpperCase()}</strong>
                    <span
                      className={`badge ${
                        i.estado === "pendiente"
                          ? "bg-warning text-dark"
                          : i.estado === "resuelta"
                          ? "bg-success"
                          : "bg-danger"
                      }`}
                    >
                      {i.estado.toUpperCase()}
                    </span>
                  </div>

                  <p className="mb-1">
                    <strong>Fecha:</strong>{" "}
                    {new Date(i.fecha_hora).toLocaleString()}
                  </p>
                  <p className="mb-1">
                    <strong>Comentario:</strong> {i.comentario}
                  </p>
                  {horaCorrecta && (
                    <p className="mb-0 text-muted">
                      <strong>Hora correcta:</strong> {horaCorrecta}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-center text-muted mt-4">No tienes incidencias.</p>
      )}
    </div>
  );
}
